module.exports = __webpack_public_path__ + "img/about_us.a72d4a22.png";